export type RouteMatch =
  | { prefix: string }
  | { exact: string }
  | { regex: string };

export type RouteManifest = {
  routes: { app: string; match: RouteMatch }[];
};

function matches(match: RouteMatch, pathname: string): boolean {
  if ('exact' in match) {
    return pathname === match.exact;
  }
  if ('prefix' in match) {
    return pathname.startsWith(match.prefix);
  }
  return new RegExp(match.regex).test(pathname);
}

export function ownerForPath(
  manifest: RouteManifest,
  path: string,
): string | undefined {
  const pathname = path.split('?')[0]?.split('#')[0] ?? path;

  for (const route of manifest.routes) {
    if (matches(route.match, pathname)) {
      return route.app;
    }
  }

  return undefined;
}
